<template>
	<modal
		id="modal"
		:exibir="exibirModal"
		:titulo="`${tituloModal}`"
		:maxWidth="500"
		class="convite-signatarios"
		@close="fecharModal"
	>
		<template #body>
			<v-row dense class="az-form-content cp-modal-form-content">
				<v-col cols="12" clas="pb-0">
					<label-personalizado class="pb-0" nome-campo="Documento"></label-personalizado>
					<texto-tooltip class="text-ver-mais" :texto="tituloDocumento" :tamanho-maximo="100"></texto-tooltip>
				</v-col>
				<v-col cols="12">
					<v-text-field
						id="email"
						v-model.trim="email"
						v-validate="'email'"
						name="E-mail"
						type="text"
						dense
						placeholder="E-mail do signatário"
						:messages="mensagemErroSignatarioJaConvidado"
						:error-messages="errors.collect('E-mail')"
						@keydown.enter.prevent="adicionaEmail"
					>
						<template #append>
							<v-btn icon :disabled="!ehEmailValido" color="primary" @click.prevent="adicionaEmail">
								<v-icon size="19">mdi-plus-circle</v-icon>
							</v-btn>
						</template>

						<template #message="{ message, key }">
							<span class="message-error">{{ message }}</span>
						</template>
					</v-text-field>
				</v-col>

				<v-col cols="12">
					<v-list v-if="!ehListaVazia" id="listaNovosEmails">
						<v-subheader class="header-list-emails">
							<span class="grey--text">Signatários à convidar:</span>
						</v-subheader>
						<v-list-item
							v-for="(email, indice) in listaNovosEmails"
							:key="email"
							dense
							class="content-list-emails"
						>
							<v-list-item-content>{{ email }}</v-list-item-content>
							<v-list-item-action>
								<v-btn icon color="primary" @click="removerEmail(indice)">
									<v-icon size="19">mdi-minus-circle</v-icon>
								</v-btn>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-col>

				<v-col cols="12">
					<v-list v-if="possuiSignatariosConvidados" id="signatariosConvidados" class="pa-0">
						<v-subheader class="header-list-emails">
							<span class="grey--text">Signatários convidados:</span>
						</v-subheader>
						<v-list-item
							v-for="signatario in signatarios"
							:key="signatario.email"
							dense
							class="content-list-emails"
						>
							<v-icon size="18" class="mr-2" :color="getCorIconeSituacaoSignatario(signatario.situacao)">
								{{ getIconeSituacaoSignatario(signatario.situacao) }}
							</v-icon>
							<v-list-item-content>{{ signatario.email }}</v-list-item-content>
							<v-btn
								v-if="exibirAcaoExcluir(signatario)"
								id="acaoExcluir"
								icon
								@click="tratarEventoExcluirSignatario(signatario)"
							>
								<v-icon size="18" color="error">mdi-delete</v-icon>
							</v-btn>
						</v-list-item>
					</v-list>
				</v-col>
			</v-row>
		</template>
		<template #actions>
			<v-divider></v-divider>
			<v-card-actions class="pb-3 pt-3">
				<v-row no-gutters>
					<botao-primario nome-botao="cancelar" @click="fecharModal">Cancelar</botao-primario>
					<botao-primario
						nome-botao="Convidar"
						class="ml-auto"
						:disabled="desabilitarAcaoConvidarSignatarios"
						@click="convidarSignatarios"
					></botao-primario>
				</v-row>
			</v-card-actions>
		</template>
	</modal>
</template>

<script>
import { situacaoSignatarioDocumentoProcessoDigital } from '@/core/constants'
import signatario from '@/views/mixins/signatarios/signatario'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'formulario-assinatura-convite',
	components: { TextoTooltip },
	mixins: [signatario],
	inject: ['$validator'],
	props: {
		exibirModal: {
			type: Boolean,
			required: true,
		},
		idAssociacao: {
			type: Number,
			required: true,
		},
		tituloModal: {
			type: String,
			required: true,
		},
		tituloDocumento: {
			type: String,
			required: true,
		},
		funcBuscar: {
			type: Function,
			required: true,
			default: () => {
				this.mostrarNotificacaoErro(
					'Necesário implementar método de busca dos signatários e passar para a propriedade.',
				)
			},
		},
	},
	emits: ['confirmar-signatarios', 'fechar-modal', 'excluir-signatario'],
	data() {
		return {
			email: null,
			qtdSignatariosConvidados: 0,
			listaNovosEmails: [],
			mensagemErroSignatarioJaConvidado: '',
			signatarios: [],
		}
	},
	computed: {
		desabilitarAcaoConvidarSignatarios() {
			return this.ehListaVazia || !this.ehFormularioValido || this.ehEmailPreenchido
		},
		ehAssinaturaEfetivadaOuPendente() {
			return this.signatarios.some(
				(signatario) =>
					signatario.email.toLowerCase() === this.email.toLowerCase() && this.ehConviteValido(signatario),
			)
		},
		ehEmailPreenchido() {
			return this.email !== null && this.email.trim().length > 0
		},
		ehEmailValido() {
			return (
				this.ehEmailPreenchido &&
				this.ehFormularioValido &&
				!this.ehAssinaturaEfetivadaOuPendente &&
				!this.ehSignatarioConvidado
			)
		},
		ehFormularioValido() {
			return this.errors.items.length === 0
		},
		ehListaVazia() {
			return this.listaNovosEmails.length === 0
		},
		ehSignatarioConvidado() {
			return this.listaNovosEmails.some((novoEmail) => novoEmail.toLowerCase() === this.email.toLowerCase())
		},
		possuiSignatariosConvidados() {
			return this.qtdSignatariosConvidados > 0
		},
	},
	watch: {
		email() {
			this.setMensagemErroSignatarioJaConvidado()
		},
	},
	async mounted() {
		await this.buscarSignatarios()
	},
	destroyed() {
		this.$validator._base.destroy()
	},
	methods: {
		async buscarSignatarios() {
			const { itens, quantidadeSignatariosConvidados } = await this.funcBuscar(this.idAssociacao)
			this.signatarios = itens
			this.qtdSignatariosConvidados = quantidadeSignatariosConvidados
		},
		async adicionaEmail() {
			await this.validarDadosFormulario()
			if (this.ehEmailValido) {
				this.listaNovosEmails.unshift(this.email)
				this.email = null
				await this.resetarValidadorFormulario()
			}
		},
		convidarSignatarios() {
			this.$emit('confirmar-signatarios', this.listaNovosEmails)
		},
		ehConviteValido(signatario) {
			return (
				situacaoSignatarioDocumentoProcessoDigital.ASSINADO.value === signatario.situacao ||
				situacaoSignatarioDocumentoProcessoDigital.ENVIADO.value === signatario.situacao ||
				situacaoSignatarioDocumentoProcessoDigital.EXPIRADO.value === signatario.situacao
			)
		},
		exibirAcaoExcluir(signatario) {
			return (
				signatario.situacao === situacaoSignatarioDocumentoProcessoDigital.ENVIADO.value ||
				signatario.situacao === situacaoSignatarioDocumentoProcessoDigital.EXPIRADO.value
			)
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		setMensagemErroSignatarioJaConvidado() {
			if (!this.email) {
				this.mensagemErroSignatarioJaConvidado = ''
				return
			}

			this.mensagemErroSignatarioJaConvidado =
				this.ehSignatarioConvidado || this.ehAssinaturaEfetivadaOuPendente
					? 'Email já incluído na listagem'
					: ''
		},
		removerEmail(indice) {
			this.listaNovosEmails.splice(indice, 1)
		},
		async resetarValidadorFormulario() {
			return await this.$validator.reset()
		},
		tratarEventoExcluirSignatario(signatario) {
			this.$emit('excluir-signatario', { idAssociacao: this.idAssociacao, signatario })
		},
		async validarDadosFormulario() {
			return await this.$validator._base.validateAll()
		},
	},
}
</script>

<style lang="stylus" scoped>
.header-list-emails
	padding 0 !important
	margin-bottom -15px !important

.content-list-emails
	padding 0 !important

.message-error
	color var(--v-error-base) !important
	caret-color var(--v-error-base) !important
</style>
